import script from "./Common.vue?vue&type=script&lang=ts"
export * from "./Common.vue?vue&type=script&lang=ts"

export default script